export default __webpack_public_path__ + "empty-groups-md.4551d1ae.svg";